import { cva, cx, type VariantProps } from '@/libs/cva'

export type ButtonVariantProps = VariantProps<typeof buttonVariants>
export const buttonVariants = cva({
	base: cx(
		'relative inline-flex w-fit items-center justify-center overflow-hidden rounded-md outline-none transition-fg',
		'disabled:border-ui-border-base disabled:bg-ui-bg-disabled disabled:text-ui-fg-disabled disabled:shadow-buttons-neutral disabled:after:hidden',
		"after:absolute after:inset-0 after:transition-fg after:content-['']"
	),
	variants: {
		variant: {
			primary: cx(
				'after:button-inverted-gradient bg-ui-button-inverted text-ui-contrast-fg-primary shadow-buttons-inverted',
				'hover:after:button-inverted-hover-gradient hover:bg-ui-button-inverted-hover',
				'active:after:button-inverted-pressed-gradient active:bg-ui-button-inverted-pressed',
				'focus-visible:!shadow-buttons-inverted-focus'
			),
			secondary: cx(
				'after:button-neutral-gradient bg-ui-button-neutral text-ui-fg-base shadow-buttons-neutral',
				'hover:after:button-neutral-hover-gradient hover:bg-ui-button-neutral-hover',
				'active:after:button-neutral-pressed-gradient active:bg-ui-button-neutral-pressed',
				'focus-visible:shadow-buttons-neutral-focus'
			),
			transparent: cx(
				'after:hidden',
				'bg-ui-button-transparent text-ui-fg-base',
				'hover:bg-ui-button-transparent-hover',
				'active:bg-ui-button-transparent-pressed',
				'focus-visible:bg-ui-bg-base focus-visible:shadow-buttons-neutral-focus',
				'disabled:!bg-transparent disabled:!shadow-none'
			),
			danger: cx(
				'shadow-buttons-colored after:button-danger-gradient bg-ui-button-danger text-ui-fg-on-color shadow-buttons-danger',
				'hover:after:button-danger-hover-gradient hover:bg-ui-button-danger-hover',
				'active:after:button-danger-pressed-gradient active:bg-ui-button-danger-pressed',
				'focus-visible:shadow-buttons-danger-focus'
			),
		},
		size: {
			small: 'txt-compact-small-plus gap-x-1.5 px-2 py-1',
			base: 'txt-compact-small-plus gap-x-1.5 px-3 py-1.5',
			large: 'txt-compact-medium-plus gap-x-1.5 px-4 py-2.5',
			xlarge: 'txt-compact-large-plus gap-x-1.5 px-5 py-3.5',
			icon: 'size-8',
		},
	},
	defaultVariants: {
		size: 'base',
		variant: 'primary',
	},
})
